import { useEffect } from 'react';
import { QueryHookOptions, useLazyQuery } from '@apollo/react-hooks';

/**
 * Method: useQuery
 * Description: enable skip on useQuery. There is a bug that currently ignores it. The bug is confirmed in the 3.2 release as well.
 * Note: https://github.com/apollographql/react-apollo/issues/3492
 */
export function useQuery<T = any>(query: any, options?: QueryHookOptions) {
  const fetchPolicy = options?.skip ? 'cache-only' : 'cache-first';
  const [execQuery, result] = useLazyQuery<T>(query, { ...options, fetchPolicy });

  if (result?.refetch) {
    result.refetch = () => {
      // workaround for this bug: https://github.com/apollographql/apollo-client/issues/6816
      try {
        result.refetch();
      } catch (e) {
        execQuery();
      }
    };
  } else if (result) {
    result.refetch = execQuery;
  }

  useEffect(() => {
    if (options?.skip !== true) {
      execQuery();
    }
  }, [execQuery, options?.skip]);

  return result;
}
